import React, { Component } from "react"
import PropTypes from 'prop-types'

import { Alert, Card, CardBody, Col, Container, Row } from "reactstrap"

// Redux
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"

//Social Media Imports
import { GoogleLogin } from "react-google-login"
// import TwitterLogin from "react-twitter-auth"
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props"

//Import config
import { facebook, google } from "../../config"

// availity-reactstrap-validation
import { AvField, AvForm } from "availity-reactstrap-validation"

// actions
import { apiError, loginUser, socialLogin } from "../../store/actions"
import  { Redirect } from 'react-router-dom'
// import images
import profile from "../../assets/images/profile-img.png"
import logo from "../../assets/images/logoSIS.png"
import lightlogo from "../../assets/images/logo-light.svg"
import $ from "jquery";
import url from "../../common/api"

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ok:"",
      message:"Mot de passe ou Login Incorrect !"
    }

    // handleValidSubmit
  this.handleValidSubmit.bind(this)
  }

  // handleValidSubmit
  //handleValidSubmit(event, values) 
  handleValidSubmit=() =>{
    this.setState({message:"Mot de passe ou Login Incorrect !"})
    if($("#email").val()!="" && $("#password").val()!="" ){
        $("#btn-charge").css("display","block")
        $("#btn-connexion").css("display","none")
    }
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json','Accept': 'application/json' },
      body: JSON.stringify({"email":$("#email").val(),"password":$("#password").val()})
  };
    
  
 fetch(url+'utilisateur/login', requestOptions)
     .then(response => response.json()
    )
    .then(data =>{console.log("data login:",data)
 
     if(data.length>0){
      //sessionStorage.removeItem("authAshia")
      $("#btn-charge").css("display","none")
      $("#btn-connexion").css("display","block")
      $("#echecAuth").css("display","none")
      sessionStorage.setItem("authAshia", JSON.stringify(data[0]))
      sessionStorage.setItem("profileAuthAshia", JSON.stringify(data[0]?.profile))
      if(data[0].status=="DESACTIVE"){
        this.setState({message:"Votre compte est suspendu;veuillez contacter votre administrateur"})
        $("#btn-charge").css("display","none")
        $("#btn-connexion").css("display","block")
        $("#echecAuth").css("display","block")
      }else{
        
        this.setState({ok: <Redirect to='/accueil'  />})
      }
      

     }else{
      $("#btn-charge").css("display","none")
      $("#btn-connexion").css("display","block")
      $("#echecAuth").css("display","block")
     }
   
   } )
  }
  
  handleRetour=()=>{
    this.setState({ok: <Redirect to='/accueil'  />});
  }

  componentDidMount() {
    this.props.apiError("")
    $("#echecAuth").css("display","none")
    $("#btn-charge").css("display","none")

    }
  signIn = (res, type) => {
    const { socialLogin } = this.props
    if (type === "google" && res) {
      const postData = {
        name: res.profileObj.name,
        email: res.profileObj.email,
        token: res.tokenObj.access_token,
        idToken: res.tokenId,
      }
      socialLogin(postData, this.props.history, type)
    } else if (type === "facebook" && res) {
      const postData = {
        name: res.name,
        email: res.email,
        token: res.accessToken,
        idToken: res.tokenId,
      }
      socialLogin(postData, this.props.history, type)
    }
  }

  //handleGoogleLoginResponse
  googleResponse = response => {
    this.signIn(response, "google")
  }

  //handleTwitterLoginResponse
  twitterResponse = () => { }

  //handleFacebookLoginResponse
  facebookResponse = response => {
    this.signIn(response, "facebook")
  }

  render() {
    return (
      <React.Fragment> {this.state.ok}
        {/* <div className="home-btn d-none d-sm-block">
          <Link to="/" className="text-dark">
            <i className="bx bx-home h2" />
          </Link>
        </div> */}
        <div className="account-pages my-5 pt-sm-5">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">

                  {/* <div className="bg-primary bg-soft">
                    <Row>
                      <Col className="col-7">
                        <div className="text-primary p-4">
                          <h5 className="text-primary">Bienvenue !</h5>
                          <p>Sign in to continue to Skote.</p>
                        </div>
                      </Col>
                      <Col className="col-5 align-self-end">
                        <img src={profile} alt="" className="img-fluid" />
                      </Col>
                    </Row>
                  </div> */}

                  <span className="avatar-title  bg-white mt-3 mb-3">
                    <img
                      src={logo}
                      alt=""
                      height="150"
                    />
                  </span>

                  <CardBody className="pt-0">
                    {/* <div className="auth-logo">
                      <Link to="/" className="auth-logo-light">
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img
                              src={logo}
                              alt=""
                              className="rounded-circle"
                              height="50"
                            />
                          </span>
                        </div>
                      </Link>
                      <Link to="/" className="auth-logo-dark">
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img
                              src={logo}
                              alt=""
                              className="rounded-circle"
                              height="50"
                            />
                          </span>
                        </div>
                      </Link>
                    </div> */}

                    
                    
                    

                    <div className="p-2">
                      <AvForm
                        className="form-horizontal"
                        
                      >
                        {this.props.error && this.props.error ? (
                          <Alert color="danger">{this.props.error}</Alert>
                        ) : null}

                        <div className="mb-3">
                          <AvField
                            name="email"
                            label="Email"
                            id="email"
                           // value="admin@themesbrand.com"
                            className="form-control"
                            placeholder="Entrez votre email"
                            type="email"
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <AvField
                            name="password"
                            label="Mot de passe"
                            id="password"
                           // value="123456"
                            type="password"
                            required
                            placeholder="Entrez votre mot de passe"
                          />
                        </div>

                        {/* <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="customControlInline"
                            style={{color:"#5FC4E1"}}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="customControlInline"
                          >
                            Se rappeler de moi
                          </label>
                        </div> */}

                        <div className="mt-3 d-grid">
                          <button
                            className="btn btn-info btn-block waves-effect waves-light"
                            onClick={this.handleValidSubmit}
                            style={{backgroundColor:"#5FC4E1"}}
                            id="btn-connexion"
                          >
                            Se connecter
                          </button>
                          <button
                            className="btn btn-info btn-block waves-effect waves-light"
                            disabled
                            id="btn-charge"
                          >
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
                            {/* <span> Connexion...</span> */}
                          </button>
                        </div>

                        <div className="mt-3 d-grid">
                          <button
                            className="btn btn-secondary btn-block waves-effect waves-light"
                            onClick={e=>this.setState({ok:<Redirect to='/accueil'  />})}
                            // style={{backgroundColor:"#5FC4E1"}}
                            id="btn-connexion"
                          >
                            Annuler
                          </button>
                      
                          
                        </div>

                        {/* <div className="mt-4 text-center">
                          <h5 className="font-size-14 mb-3">Sign in with</h5>

                          <ul className="list-inline">
                            <li className="list-inline-item">
                              <FacebookLogin
                                appId={facebook.APP_ID}
                                autoLoad={false}
                                callback={this.facebookResponse}
                                render={renderProps => (
                                  <Link
                                    to={""}
                                    className="social-list-item bg-primary text-white border-primary"
                                  // onClick={renderProps.onClick}
                                  >
                                    <i className="mdi mdi-facebook" />
                                  </Link>
                                )}
                              />
                            </li>
                            <li className="list-inline-item">
                              <GoogleLogin
                                clientId={google.CLIENT_ID}
                                render={renderProps => (
                                  <Link
                                    to={""}
                                    className="social-list-item bg-danger text-white border-danger"
                                  // onClick={renderProps.onClick}
                                  >
                                    <i className="mdi mdi-google" />
                                  </Link>
                                )}
                                onSuccess={this.googleResponse}
                                onFailure={() => { }}
                              />
                            </li>
                          </ul>
                        </div> */}

                        {/* <div className="mt-4 text-center">
                          <Link to="/forgot-password" className="text-muted">
                            <i className="mdi mdi-lock me-1" /> Forgot your
                            password?
                          </Link>
                        </div> */}
                      </AvForm>
                    </div>
                    <div>
                    <div id="echecAuth" class="alert alert-danger" role="alert">
                      {this.state.message}
                    </div>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  {/* <p>
                    Don't have an account ?{" "}
                    <Link
                      to="register"
                      className="fw-medium text-primary"
                    >
                      {" "}
                      Signup now{" "}
                    </Link>{" "}
                  </p> */}
                  <p>
                    © {new Date().getFullYear()} SIS. Conçu par BM-SIS
                    {/* avec{" "}
                    <i className="mdi mdi-heart text-danger" />  */}
                     
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

Login.propTypes = {
  apiError: PropTypes.any,
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func
}

const mapStateToProps = state => {
  const { error } = state.Login
  return { error }
}

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError, socialLogin })(Login)
)
